import { formatDate } from '../services/formatter'

const getDateTooltipTitle = (date, dateDetails) =>
  dateDetails
    ? `${formatDate(date, false)} (${dateDetails})`
    : formatDate(date, false)

export default getDateTooltipTitle
